import { groupEventsByUpload } from './FeedList';

/**
 * Outcome for one upload attempt — mirrors SubmissionGroupRow in MetricDrillModal.
 */
export function getSubmissionGroupStatus(group) {
  const successEvent = group?.rows?.find((r) => r.meta?.event === 'gallery_ready');
  const failedEvent = group?.rows?.find((r) => r.meta?.event === 'upload_failed');
  if (successEvent) return 'success';
  if (failedEvent) return 'failed';
  return 'pending';
}

/**
 * Upload-attempt groups shown in the Submissions drill-down (newest first).
 */
export function buildSubmissionGroups(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  return groupEventsByUpload(rows)
    .filter((g) =>
      g.rows.some(
        (r) =>
          r.meta?.event === 'floorplan_uploaded' || r.meta?.event === 'upload_failed'
      )
    )
    .sort((a, b) => {
      const anchorTs = (g) => {
        const anchor =
          g.rows.find((r) => r.meta?.event === 'floorplan_uploaded') || g.rows[0];
        return new Date(anchor?.timestamp || 0).getTime();
      };
      return anchorTs(b) - anchorTs(a);
    });
}

/**
 * Aggregate submission groups into card / drill-down totals.
 * Counts upload attempts (one per list row), not raw gallery_ready events.
 */
export function summarizeSubmissionGroups(groups) {
  let processed = 0;
  let failed = 0;
  let pending = 0;

  (groups || []).forEach((group) => {
    const status = getSubmissionGroupStatus(group);
    if (status === 'success') processed += 1;
    else if (status === 'failed') failed += 1;
    else pending += 1;
  });

  const total = processed + failed + pending;
  const resolved = processed + failed;
  const successRate =
    resolved > 0 ? Math.round((processed * 100) / resolved) : 0;

  return { processed, failed, pending, total, resolved, successRate };
}

export function summarizeSubmissionRows(rows) {
  return summarizeSubmissionGroups(buildSubmissionGroups(rows));
}
